import ModalWrap from './ModalWrap'

export default ModalWrap
